import { setCookieViaAction } from "@/actions/user.actions";
import { apiSdkInstance } from "@/apiSdk/stageApiSdk.instance";
import {
  CookiesEnum,
  cookiesValues,
  INDIA_COUNTRY_CODE,
  LocalStorageKeysEnum,
  SUBSCRIPTION_STATUS,
} from "@/constants/constants";
import { getClientSideCookieValue } from "@/utils/common.helpers";
interface LocationData {
  country: string | undefined;
  city: string | null;
}

let cachedLocation: LocationData | null = null;

export const getLocation = (): LocationData => {
  if (cachedLocation) return cachedLocation;

  const location: LocationData = {
    country: getClientSideCookieValue(cookiesValues[CookiesEnum.UserCountry]),
    city: localStorage.getItem(LocalStorageKeysEnum.CITY),
  };

  // Only cache if we have real data; avoid locking in nulls before location is fetched
  if (location.country || location.city) {
    cachedLocation = location;
  }

  return location;
};

/** Pure check — works on both server and client. */
export const isInternationalCountry = (country?: string | null): boolean => {
  if (!country) return false;
  return country !== INDIA_COUNTRY_CODE;
};

/** Client-only convenience wrapper that reads the userCountry cookie. */
export const isInternationalUser = (): boolean => {
  const country = getClientSideCookieValue(
    cookiesValues[CookiesEnum.UserCountry],
  );
  return isInternationalCountry(country);
};

/** Pure function for server-side access check using cookie values. */
export const hasActiveAccessFromCookies = (cookies: {
  status?: string;
  isGlobalPlan?: string;
  userCountry?: string;
}): boolean => {
  const isSubscribed =
    cookies.status === String(SUBSCRIPTION_STATUS.SUBSCRIBED);
  if (!isSubscribed) return false;
  if (cookies.isGlobalPlan === "true") return true;
  return !isInternationalCountry(cookies.userCountry);
};

export const fetchAndSetLocationInLocalStorage = async () => {
  const response = await apiSdkInstance.user.fetchUserLocation();

  localStorage.setItem(LocalStorageKeysEnum.CITY, response.city);

  cachedLocation = {
    country: response.country,
    city: response.city,
  };

  await setCookieViaAction({
    key: cookiesValues[CookiesEnum.UserCountry],
    value: response.country,
  });

  return response;
};
